(function () {
  // Ensure Swiper CSS + JS is available. Single global promise to avoid duplicate loads.
  if (!window.__swiper_loader_promise) {
    window.__swiper_loader_promise = (function () {
      return new Promise((resolve) => {
        if (window.Swiper) return resolve(window.Swiper);

        // Add CSS if not present
        if (!document.querySelector('link[href*="swiper-bundle.min.css"]')) {
          const l = document.createElement('link');
          l.rel = 'stylesheet';
          l.href = 'https://unpkg.com/swiper@9/swiper-bundle.min.css';
          document.head.appendChild(l);
        }

        // Add script
        const s = document.createElement('script');
        s.src = 'https://unpkg.com/swiper@9/swiper-bundle.min.js';
        s.async = true;
        s.onload = () => resolve(window.Swiper);
        s.onerror = () => {
          console.warn('[carousel-component] Failed to load Swiper from CDN.');
          resolve(null);
        };
        document.head.appendChild(s);
      });
    })();
  }

  class carouselComponentCustom extends HTMLElement {
    constructor() {
      super();
      this.swiperIns = null;
      this.carousel = null;
      this.next = null;
      this.prev = null;
      this.paginationEl = null;
      this.hasListener = false;
    }

    connectedCallback() {
      if (!this.hasListener) {
        this.addEventListener('rvp:rendered', () => {
          if (this.swiperIns) {
            this.swiperIns.update();
            this.setSwiperHeight();
          } else {
            this.initWhenReady();
          }
        });
        this.hasListener = true;
      }

      // init when element is connected and Swiper is present (or loaded)
      this.initWhenReady();
    }

    initWhenReady() {
      // wait for Swiper to be available
      window.__swiper_loader_promise.then((SwiperLib) => {
        if (!SwiperLib) {
          console.warn('[carousel-component] Swiper library is not available.');
          return;
        }
        // If slides exist (SSR/fast render), init immediately
        if (!this.swiperIns && this.querySelector('.swiper-wrapper > *')) {
          this.initSlider();
        }
      });
    }

    initSlider() {
      if (this.swiperIns) return;

      if (typeof Swiper === 'undefined') {
        console.warn('[carousel-component] Swiper not found on window.');
        return;
      }

      this.carousel = this.querySelector('.swiper');
      if (!this.carousel) return;

      // Because arrows are inside the same carousel element, querySelector will find them
      this.next = this.carousel.querySelector('[id^="swiper-next-"]');
      this.prev = this.carousel.querySelector('[id^="swiper-prev-"]');
      this.paginationEl = this.carousel.querySelector('.swiper-pagination');

      const getBool = (key, def = false) => {
        const v = this.carousel.getAttribute(key);
        if (v === null) return def;
        return String(v) === 'true';
      };
      const getNum = (key, def = 0) => {
        const v = parseFloat(this.carousel.getAttribute(key));
        return isNaN(v) ? def : v;
      };

      this.loop = getBool('data-loop', true);
      this.arrow = getBool('data-arrow', true);
      this.pagination = getBool('data-pagination', true);
      this.autoplay = getBool('data-autoplay', false);
      this.interval = getNum('data-interval', 5000);
      this.transition = getNum('data-transition', 300);

      this.desktop_item = getNum('data-desktop-columns', 4);
      this.mobile_item = getNum('data-mobile-columns', 1);

      this.desktop_spacing = getNum('data-desktop-spacing-grid-horizontal', 20);
      this.spacing = getNum('data-mobile-spacing-grid-horizontal', 12);

      // fallback safety
      this.desktop_item = isNaN(this.desktop_item) ? 4 : this.desktop_item;
      this.mobile_item = isNaN(this.mobile_item) ? 1 : this.mobile_item;

      const breakpoints = {
        640:  { slidesPerView: this.mobile_item,  spaceBetween: this.spacing },
        1024: { slidesPerView: this.desktop_item, spaceBetween: this.desktop_spacing }
      };

      this.swiperIns = new Swiper(this.carousel, {
        loop: this.loop,
        spaceBetween: this.spacing,
        centeredSlides: true,
        autoplay: this.autoplay ? {
          delay: this.interval,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        } : false,
        speed: this.transition,
        slidesPerView: this.mobile_item,
        pagination: this.pagination ? { el: this.paginationEl, clickable: true } : false,
        navigation: this.arrow ? { nextEl: this.next, prevEl: this.prev } : false,
        breakpoints,
        on: {
          init: () => this.setSwiperHeight(),
          resize: () => this.setSwiperHeight(),
          imagesReady: () => this.setSwiperHeight()
        }
      });
    }

    slideAutoplayStop() { return this.swiperIns?.autoplay?.stop?.(); }
    slideAutoplayStart() { return this.swiperIns?.autoplay?.start?.(); }
    carouselSlideTo(i)   { return this.loop ? this.swiperIns?.slideToLoop?.(i) : this.swiperIns?.slideTo?.(i); }

    destroySwiper() {
      if (this.swiperIns) {
        this.swiperIns.destroy(true, true);
        this.swiperIns = null;
      }
    }

    setSwiperHeight() {
      const wrapper = this.carousel?.querySelector('.swiper-wrapper');
      if (wrapper) this.style.setProperty('--swiper-height', `${wrapper.offsetHeight}px`);
    }
  }

  if (!customElements.get('carousel-component-custom')) {
    customElements.define('carousel-component-custom', carouselComponentCustom);
  }
})();